import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const EditModal = (props) => {
  toast.configure()
  const [exams, setExams] = useState([])
  const [data, setData] = useState()

  const getData = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'auth/fetchStudentById', {
        id: props.id,
      })
      .then((res) => {
        setData(res.data.data[0])
      })
      .catch((err) => {})
  }

  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setData({ ...data, [name]: value })
  }
  // to get already declared exams
  const getExam = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'exam/fetchAllExams')
      .then((res) => {
        setExams(res.data.data)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getExam()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const update = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'auth/updateStudentProfile', {
        id: props.id,
        exam_id: data.exam_id,
        start_date: data.start_date,
        end_date: data.end_date,
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
      .catch((err) => {})
  }
  return (
    <div>
      <button
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#editModal"
        type="button"
        onClick={getData}
      >
        Edit Details
      </button>
      {/* modal */}

      <div
        className="modal fade modal-lg"
        id="editModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="editModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            {data ? (
              <div className="modal-body">
                <div className="row">
                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6> Name</h6>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={data.name}
                      readOnly
                    />
                  </div>
                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6> Email address</h6>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={data.email}
                      readOnly
                    />
                  </div>
                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6>Contact</h6>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={data.contact}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6>College</h6>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={data.institute}
                      readOnly
                    />
                  </div>
                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6>Course</h6>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={data.course}
                      readOnly
                    />
                  </div>
                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6>Academic Year</h6>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={data.academic_year}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6>Enrollment</h6>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={data.enrollment}
                      readOnly
                    />
                  </div>

                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6>Recruitment</h6>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={data.ins_status}
                      readOnly
                    />
                  </div>

                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6>Position Applied For</h6>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleFormControlInput1"
                      defaultValue={data.applied_for}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  {data.exam_name ? (
                    <div className="mb-3 col-md">
                      <label
                        for="exampleFormControlInput1"
                        className="form-label"
                      >
                        <h6>Assigned Exam</h6>
                      </label>
                      <select
                        className="form-select"
                        id="floatingSelect"
                        aria-label="Floating label select example"
                        defaultValue={data.exam_id}
                        name="exam_id"
                        onChange={handleChange}
                      >
                        <option value="" disabled selected>
                          Select
                        </option>
                        {exams?.map((i, index) => {
                          return (
                            <option value={i.exam_id} key={index}>
                              {i.exam_name}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                  ) : (
                    ''
                  )}
                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6>Exam Start Date</h6>
                    </label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="start_date"
                      defaultValue={data.start_date}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3 col-md">
                    <label
                      for="exampleFormControlInput1"
                      className="form-label"
                    >
                      <h6>Exam End Date</h6>
                    </label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="end_date"
                      defaultValue={data.end_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={update}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
